function replaceSlashes(inputString) {
    if (inputString){
        return inputString.replace(/[\/:]/g, '_')
    } else{
        return ""
    }
}
export { replaceSlashes}